import en from './en.js'

import logScope from 'log-scope'
const log = logScope('locale')

log.pause()

export default Vue => {
  Vue.mixin({
    methods: {
      __ (str) {
        const language = this.$store.getters.currentLanguage
        const translation = language.id === 'GB' ? en[str] : str

        if (!translation) {
          log.danger(`No (${language.name}) translation for: ${str}`)
          return str
        }

        return translation
      },
    },
  })
}
